import { useState, useEffect, useRef } from 'react'
import { StyledSelect } from '@/components/styles'

export default function SelectBase({
  title,
  selected = false,
  children = [],
  size = '',
  closeOnClick = false,
  disabled = false,
  ...otherProps
}) {
  const wrapper = useRef(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    window.addEventListener('click', onClickOutside)
    return () => window.removeEventListener('click', onClickOutside)
  }, [open])

  const onClickOutside = e => {
    if (closeOnClick) {
      open && setOpen(!open)
      return
    }
    if (!wrapper.current.contains(e.target) || wrapper.current === e.target) {
      open && setOpen(!open)
    }
  }

  return (
    <StyledSelect ref={wrapper} open={open} {...otherProps}>
      <StyledSelect.Head
        open={open}
        selected={selected}
        disabled={disabled}
        onClick={() => {
          if (!disabled) {
            setOpen(!open)
          }
        }}
      >
        {title}
      </StyledSelect.Head>
      <StyledSelect.Body visible={open} size={size}>
        <StyledSelect.Content>{children}</StyledSelect.Content>
      </StyledSelect.Body>
    </StyledSelect>
  )
}
